import { NgModule } from '@angular/core'
import { ContactBoxLineComponent } from './contact-box-line.component'
import { CommonModule } from '@angular/common'
import { MbI18nModule } from '../../../../translations/mb-i18n.module'
import { CmsDirectivesModule } from '../../../directives/cms-directives.module'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { LinkModule } from '../../shared/link/link.module'

@NgModule({
  declarations: [
    ContactBoxLineComponent
  ],
  imports: [
    CommonModule,
    MbI18nModule,
    CmsDirectivesModule,
    CmsComponentsBaseModule,
    LinkModule
  ],
  exports: [
    ContactBoxLineComponent
  ]
})
export class ContactBoxLineModule {
}
